import { useMemo } from 'react';

import { useTabPages } from '@ts-core/hooks/ui';

import { useMediaPage } from 'modules/media/pages/MediaPage';
import { useDocumentsPage } from 'modules/documents/pages/DocumentsPage';

export default function useSubjectTabs() {
  const mediaPageData = useMediaPage();
  const documentsPageData = useDocumentsPage();

  const defaultTab = mediaPageData.tab;

  const pages = useMemo(() => {
    const result = [mediaPageData, documentsPageData];
    return result;
  }, [mediaPageData, documentsPageData]);

  const tabPagesData = useTabPages({ pages, slugParam: 'tabSlug' });

  return { ...tabPagesData, defaultTab };
}
